import React from "react";
import styles from "../TagDialog.module.css";
import { CustomButton, CustomTextField } from "../../../../../common/components";

const UpdateDateRow = ({ label, onDateChange, updateButtonLabel, date, onUpdateDate }) => (
	<div className={`${styles["margin-bottom"]} ${styles["padding-top"]}`}>
		<CustomTextField
			InputLabelProps={{ shrink: true, required: false }}
			label={label}
			type="date"
			onChange={onDateChange}
		/>
		<CustomButton color="primary" onClick={() => onUpdateDate(date)}>
			{updateButtonLabel}
		</CustomButton>
	</div>
);
export default UpdateDateRow;
